import TopBanner from './components/TopBanner';
import HeroSection from './components/HeroSection';
import PainPointsSection from './components/PainPointsSection';
import ImagineSection from './components/ImagineSection';
import SolutionSection from './components/SolutionSection';
import AboutSection from './components/AboutSection';
import ProgramSection from './components/ProgramSection';
import BonusSection from './components/BonusSection';
import ResultsSection from './components/ResultsSection';
import TestimonialsSection from './components/TestimonialsSection';
import ForWhoSection from './components/ForWhoSection';
import FAQSection from './components/FAQSection';
import CTAFinal from './components/CTAFinal';
import SiteFooter from './components/SiteFooter';

const FORM_ACTION = 'https://readdy.ai/api/form/d72g85smc4tbhfnc6e30';

const HomePage = () => (
  <div className="min-h-screen font-sans">
    <TopBanner />
    <HeroSection formAction={FORM_ACTION} />
    <PainPointsSection />
    <ImagineSection />
    <SolutionSection />
    <AboutSection />
    <ProgramSection />
    <BonusSection />
    <ResultsSection />
    <TestimonialsSection />
    <ForWhoSection />
    <FAQSection />
    <CTAFinal />
    <SiteFooter />
  </div>
);

export default HomePage;
